import { Popup, ToolbarItem as PopupToolbarItem } from 'devextreme-react/popup';
import { useCallback, useState, useMemo, useEffect, useRef } from 'react';
import { useAppSelector, useAppDispatch } from '../../../contexts/hooks';
import { shallowEqual } from 'react-redux';
import Order from '../Components/Orders';
import Patient from '../Components/Patient';
import { clearPatient, setData, setLoading, setMode } from '../../../contexts/slices/preorders';
import { Button, DataGrid, Form, LoadIndicator, Tabs, Tooltip } from 'devextreme-react';
import { Column, Editing } from 'devextreme-react/data-grid';
import { Toolbar as DxToolbar, Item as DxItem } from 'devextreme-react/toolbar';
import { newToast, LabRefChip, LiquidarOrden } from '../../../components';
import '../Preorders.scss';
import { useApiPatient } from '../../../api/api.patient';
import { CustomFilters, TypeTableFilter } from '../../../types/types.system';
import { useApiPreorders } from '../../../api/api.Preorders';
import { useApiConfiguration } from '../../../api/api.configuration';
import { FacturacionTarifas } from '../../../types/types.facturacion';
import { formatNumber } from 'devextreme/localization';
import { Disccount, ordMuestras } from '../../../images/icons';
import { useScreenSize } from '../../../utils/media-query';
import { SampleTubesPanel, TmBcListDTO } from '../../../components/library/info-order/OrderModules/components/SampleTubesPanel';
import { ButtonItem, Label, SimpleItem } from 'devextreme-react/form';
import { SysI_CodBarrasImpresoras } from '../../../types/types.barcodes';
import { useApiBarcodes } from '../../../api/api.barcodes';
import { setModalBarcodePrintersVisible } from '../../../contexts/slices/config';
import { useApiOrders } from '../../../api/api.orders';
import { NotesPreorders } from '../Components/Notes';
import { Notas, EAFacturarEnableOptions } from '../../../types/types.preorders';
import { PreorderStudiesSearchSelect, PreorderStudyItem, ModalFEVRIPS, FEVRIPSStatusButton } from './components';
import { ProfilesSearchSelect, ProfileItem } from '../../../components/library/info-order/OrderModules/components';
import { useApiFunctionsResult } from '../../../components/library/info-order/OrderModules/Functions/Results';

type PopupProps = {
  visible: boolean;
  wrapperAttr?: { class: string };
  setVisible: (update: boolean) => void;
  currentData?: any[];
  idPreOrder?: number;
  setCurrentPreOrderCreated?: (id: number) => void;
  idPatient?: number;
};

type discounttp = {
  type: 'value' | 'percentage' | null;
  value: number;
};
const discount: discounttp = { type: null, value: 0 };

const Index = ({ visible, setVisible, wrapperAttr = { class: '' }, currentData, idPreOrder, setCurrentPreOrderCreated, idPatient }: PopupProps) => {
  const ColumnsContainerOrderOrders = useAppSelector((x) => x.configuration.Data?.Config_General.filter((x) => x.Cgn_Nombre === 'ColumnsContainerOrderOrders')[0], shallowEqual)?.Cgn_Resultado;
  const ColumnsContainerPatientOrders = useAppSelector((x) => x.configuration.Data?.Config_General.filter((x) => x.Cgn_Nombre === 'ColumnsContainerPatientOrders')[0], shallowEqual)?.Cgn_Resultado;
  const CreateOrderAutomaticInPreorder: boolean = JSON.parse(useAppSelector((x) => x.configuration.Data?.Config_General.filter((x) => x.Cgn_Nombre === 'CreateOrderAutomaticInPreorder')[0].Cgn_Resultado) || 'false');
  const AutomaticBarcodePrint: boolean = JSON.parse(useAppSelector((x) => x.configuration.Data?.Config_General.filter((x) => x.Cgn_Nombre === 'AutomaticBarcodePrint')[0])?.Cgn_Resultado || 'false');
  const ModuleBarcode: boolean = JSON.parse(useAppSelector((x) => x.configuration.Data?.Config_General.filter((x) => x.Cgn_Nombre === 'ModuleBarcode')[0].Cgn_Resultado) || 'false');
  const ModuleFEVRIPS: boolean = JSON.parse(useAppSelector((x) => x.configuration.Data?.Config_General.filter((x) => x.Cgn_Nombre === 'ModuleFEVRIPS')[0].Cgn_Resultado) || 'false');
  const AFacturarEnableOptionsRaw = useAppSelector((x) => x.configuration.Data?.Config_General.filter((x) => x.Cgn_Nombre === 'AFacturarEnableOptions')[0], shallowEqual)?.Cgn_Resultado;
  const AFacturarEnableOptions: EAFacturarEnableOptions = AFacturarEnableOptionsRaw ? parseInt(AFacturarEnableOptionsRaw) : EAFacturarEnableOptions.FEV;

  const Prm_Preordenes_Notas_R = useAppSelector((x) => x.userInfo.Permissions?.Prm_Preordenes_Notas_R);
  const Prm_FactFEVRIPS = useAppSelector((x) => x.userInfo.Permissions?.Prm_FactFEVRIPS);
  const Prm_FactCajaLiquidar = useAppSelector((x) => x.userInfo.Permissions?.Prm_FactCajaLiquidar);
  const profiles = useAppSelector((x) => x.configuration.Data?.Perfiles || [], shallowEqual);
  // Modal para elegir entre eliminar solo el estudio o todo el perfil
  const [deleteProfileModal, setDeleteProfileModal] = useState<{ studyId: number; profileId: number; profileName: string } | null>(null);
  const sedeId = useAppSelector((x) => x.userInfo.Location?.Location);
  const mode = useAppSelector((x) => x.globalPreOrder.Mode);
  const modePatient = useAppSelector((x) => x.globalOrders.CurrentOrder.ModePatient);

  // Estado para el modal de FEV/RIPS
  const [modalFEVRIPSVisible, setModalFEVRIPSVisible] = useState(false);
  const { handlePrintBarcodesLabel } = useApiFunctionsResult();
  const dataGridRef = useRef<DataGrid>(null);
  const [itemsAdded, setItemsAdded] = useState<FacturacionTarifas[]>([]);
  const [listsData, setListsData] = useState<string[]>(['Estudios']);
  const [modalDiscountVisible, setModalDiscountVisible] = useState(false);
  const Prm_CodBarImprimir = useAppSelector((x) => x.userInfo.Permissions?.Prm_CodBarImprimir);
  const PreorderData = useAppSelector((x) => x.globalPreOrder.PreOrder);
  const PatientData = useAppSelector((x) => x.globalPreOrder.PatientData);
  const { GetTarifasByIdContratoWithStudies } = useApiConfiguration();
  const [lstTarifas, setLstTarifas] = useState([]);
  const { NewOrderFromPreOrders, GetSampleTypeAndBarcode } = useApiOrders();
  const idPrRedx = useAppSelector((x) => x.globalPreOrder.PreOrder?.POrd_Id); //Usado para las notas unicamente
  const [loadingNotes, setLoadingNotes] = useState(false);
  const { isSmall, isXSmall } = useScreenSize();
  const [selectedIndex, setSelectedIndex] = useState(0);
  const frmRef = useRef<Form>(null);
  const [currentNotes, setCurrentNotes] = useState<Notas[]>([]);
  const [sampleTubesData, setSampleTubesData] = useState<TmBcListDTO[]>([]);
  const [samplePanelVisible, setSamplePanelVisible] = useState<boolean>(true);
  const [muestrasPopupVisible, setMuestrasPopupVisible] = useState<boolean>(false);
  const [currentPrinter, setCurrentPrinter] = useState<SysI_CodBarrasImpresoras | undefined>(undefined);
  const { getPrinters } = useApiBarcodes();
  const cmbLabRef = useAppSelector((x) => x.configuration.Data?.LabReferencia) || [];

  // Dentro de tu componente
  const [totals, setTotals] = useState({
    subtotal: 0,
    discount: 0,
    total: 0,
  });

  const { Create, Edit, GetById, GetNotes } = useApiPreorders();
  const dispatch = useAppDispatch();
  const [loadingPac, setLoadingPac] = useState(false);
  const { findUser } = useApiPatient();

  // Resuelve el nombre de un perfil a partir de su id, usando la config de perfiles.
  const getProfileName = useCallback(
    (pfeId?: number | null) => {
      if (!pfeId) return undefined;
      return profiles.find((p: any) => p.Rpe_Pfe_Id === pfeId)?.SysI_PerfilesEstudios?.Pfe_Nombre;
    },
    [profiles]
  );

  // Mapea un detalle de preorden (backend) al item del grid, conservando el perfil.
  const mapDetalleToItem = useCallback(
    (x: any): FacturacionTarifas => ({
      ...x,
      Tf_Valor: x.Rpre_ValUnitario,
      Tf_Es_Id: x.Rpre_Es_Id,
      Rpe_Pfe_Id: x.Rpre_Pfe_Id ?? null,
      Profile: getProfileName(x.Rpre_Pfe_Id),
    }),
    [getProfileName]
  );

  const fetchDataNotes = useCallback(async () => {
    const currentId = idPreOrder && idPreOrder > 0 ? idPreOrder : idPrRedx;
    if (Prm_Preordenes_Notas_R && currentId && currentId > 0) {
      setLoadingNotes(true);
      const res = await GetNotes(currentId);
      setCurrentNotes(res);
      setLoadingNotes(false);
    }
  }, [setCurrentNotes, GetNotes, idPreOrder, idPrRedx, Prm_Preordenes_Notas_R]);

  const updateNotes = (boolean: boolean) => {
    if (boolean) {
      fetchDataNotes();
    }
  };

  // Handler para abrir el modal de FEV/RIPS
  const handleOpenFEVRIPSModal = useCallback(() => {
    if (!ModuleFEVRIPS) return;
    setModalFEVRIPSVisible(true);
  }, [ModuleFEVRIPS]);

  // Función para refrescar los datos de la preorden (usado después de operaciones FEV/RIPS)
  const refreshPreorderData = useCallback(async () => {
    const currentId = PreorderData?.POrd_Id || idPreOrder;
    if (currentId && currentId > 0) {
      const res = await GetById(currentId);
      if (res) {
        const data = res.Detalle?.map(mapDetalleToItem) || [];
        setItemsAdded(data);
        res.Detalle = undefined;
        dispatch(setData(res));
      }
    }
  }, [PreorderData?.POrd_Id, idPreOrder, GetById, dispatch, mapDetalleToItem]);

  const onCancelClick = () => {
    dispatch(clearPatient());
    dispatch(setMode({ mode: 'view' }));
    setVisible(false);
  };

  // Cargar los datos de las impresoras al iniciar el componente
  useEffect(() => {
    getPrinterInfo();
  }, []);

  const getPrinterInfo = async () => {
    if (!ModuleBarcode) {
      return;
    }
    //Verificar si tenemos en localStorage una impresora configurada.
    const printerData = localStorage.getItem('defaultPrinter');
    let printer: SysI_CodBarrasImpresoras | undefined;
    if (printerData) {
      printer = JSON.parse(printerData);
      setCurrentPrinter(printer);
    } else {
      const printers = await getPrinters();
      if (printers?.length === 0) {
      } else if (printers?.length === 1) {
        localStorage.setItem('defaultPrinter', JSON.stringify(printers[0]));
        printer = printers[0];
        setCurrentPrinter(printer);
        newToast('INFO', `Se ha establecido la impresora '${printer.Cbp_Nombre}' como predeterminada.`, 5);
      } else {
        if (Prm_CodBarImprimir) {
          dispatch(setModalBarcodePrintersVisible(true));
        }
      }
    }
  };

  // Cargar las notas al abrir el modal o al cambiar de modo (ej: después de crear)
  useEffect(() => {
    if (Prm_Preordenes_Notas_R && mode !== 'new' && visible) {
      setListsData(['Estudios', 'Notas']);
      if ((idPrRedx && idPrRedx > 0) || idPreOrder) {
        fetchDataNotes();
      }
    }
  }, [visible, mode]);

  //Actualizar totales cada que se agregue un nuevo item
  useEffect(() => {
    updateTotals();
  }, [itemsAdded]);

  // Efecto para cargar tubos/muestras cada vez que cambian los estudios
  const studyIdsKey = useMemo(() => {
    return itemsAdded.map((s) => s.Tf_Es_Id).sort((a, b) => a - b).join(',');
  }, [itemsAdded]);

  useEffect(() => {
    if (!studyIdsKey) {
      setSampleTubesData([]);
      return;
    }
    const studyIds = studyIdsKey.split(',').map(Number);
    GetSampleTypeAndBarcode(studyIds).then((res: TmBcListDTO[]) => {
      setSampleTubesData(res || []);
    });
  }, [studyIdsKey]);

  // Para consultar los datos del paciente al abrir el modal
  useEffect(() => {
    if (mode !== 'new' && PreorderData && PreorderData.POrd_Pc_Id && modePatient === 'view') {
      const filters: CustomFilters[] = [{ Field: 'Pc_Id', Value: PreorderData.POrd_Pc_Id, TypeFilter: TypeTableFilter.Equal }];
      findUser(filters, setLoadingPac, true, 'preorders');
    }
  }, [PreorderData]);

  // Cargar las tarifas del contrato seleccionado
  useEffect(() => {
    if (PreorderData.POrd_Cn_Id && PreorderData.POrd_Cn_Id > 0) {
      GetTarifasByIdContratoWithStudies(PreorderData.POrd_Cn_Id).then((res) => {
        setLstTarifas(res);
        if (mode !== 'view') {
          // Ahora no quiero limpiar los items sino que si hay un contrato nuevo deseo comparar los estudios agregados y cambiarles la tarifa y sino existe en el nuevo contrato, ponerlo con tarifa 0
          setItemsAdded(
            itemsAdded.map((item) => {
              const newTarifa = res.find((t) => t.Tf_Es_Id === item.Tf_Es_Id);
              return {
                ...item,
                Tf_Valor: newTarifa ? newTarifa.Tf_Valor : 0,
              };
            })
          );
        }
      });
    }
  }, [PreorderData.POrd_Cn_Id]);

  // Limpiar los datos al cerrar la modal o al crear una nueva preorden
  useEffect(() => {
    if ((visible && mode === 'new') || !visible) {
      if (idPatient && idPatient > 0) {
        const filters: CustomFilters[] = [{ Field: 'Pc_Id', Value: idPatient, TypeFilter: TypeTableFilter.Equal }];
        findUser(filters, setLoadingPac, true, 'preorders');
      }
      //Limpiar los tipos de descuento
      discount.type = null;
      discount.value = 0;
      setItemsAdded([]);
      frmRef.current?.instance?.resetValues();
    }
  }, [visible]);

  // Este efecto es usado unicamente para visualizar la preorden desde otros modulos como Citas, Cotizaciones, etc.....
  useEffect(() => {
    if (idPreOrder && idPreOrder > 0 && visible) {
      dispatch(setMode({ mode: 'view', idPreOrder: -1 }));
      GetById(idPreOrder).then((res) => {
        if (res) {
          const data = res.Detalle.map(mapDetalleToItem);
          setItemsAdded(data);
          //Eliminamos el detalle de res
          res.Detalle = undefined;
          dispatch(setData(res));
          //Asignamos los datos a los descuentos aplicados
          if (res.POrd_TipoDescuento && res.POrd_TipoDescuentoValor) {
            discount.type = res.POrd_TipoDescuento === 1 ? 'percentage' : 'value';
            discount.value = res.POrd_TipoDescuentoValor;
            frmRef.current?.instance?.updateData('type', discount.type);
            frmRef.current?.instance?.updateData('value', discount.value);
          } else {
            discount.type = null;
            discount.value = 0;
            frmRef.current?.instance?.resetValues();
          }
        }
      });
    }
  }, [idPreOrder, visible]);

  // // Este efecto es usado unicamente para visualizar la preorden desde el modulo de Preordenes
  // useEffect(() => {
  //   if (visible && mode === 'view' && currentData && !idPreOrder) {
  //     let data;
  //     data = currentData.map((x) => {
  //       return { ...x, Tf_Valor: x.Rpre_ValUnitario, Tf_Es_Id: x.Rpre_Es_Id };
  //     });

  //     setItemsAdded(data);

  //     if (PreorderData.POrd_TipoDescuento && PreorderData.POrd_TipoDescuentoValor) {
  //       frmRef.current?.instance?.updateData('type', PreorderData.POrd_TipoDescuento === 1 ? 'percentage' : 'value');
  //       frmRef.current?.instance?.updateData('value', PreorderData.POrd_TipoDescuentoValor);
  //       discount.type = PreorderData.POrd_TipoDescuento === 1 ? 'percentage' : 'value';
  //       discount.value = PreorderData.POrd_TipoDescuentoValor;
  //     } else {
  //       frmRef.current?.instance?.resetValues();
  //       discount.type = null;
  //       discount.value = 0;
  //     }
  //   }
  // }, [PreorderData]);

  // Handler para selección de estudio con nuevo componente
  const handleStudySelected = useCallback(
    (study: PreorderStudyItem) => {
      try {
        // Verificar si el estudio ya está agregado
        const isAlreadyAdded = itemsAdded.some((item) => item.Tf_Es_Id === study.Tf_Es_Id);

        if (isAlreadyAdded) {
          newToast('WARNING', `El estudio '${study.name}' ya está agregado`, 3);
          return;
        }
        // Crear el item para agregar al grid
        const newItem: FacturacionTarifas = {
          Tf_Id: 0, // Nuevo item
          Tf_Cn_Id: PreorderData.POrd_Cn_Id || 0,
          Tf_Es_Id: study.Tf_Es_Id,
          Tf_Valor: study.Tf_ValorTarifa || study.price || 0,
          Tf_Estado: true,
          Estudio: {
            Es_Id: study.Tf_Es_Id,
            Es_Aa_Id: 0,
            Es_Pd_Id: 0,
            Es_Lr_Id: study.labref,
            Es_Codigo: study.Tf_Es_Codigo,
            Es_Nombre: study.Tf_Es_Nombre,
            Es_Abreviatura: '',
            Es_Homologacion: null,
            Es_Descripcion: null,
            Es_Tecnica: null,
            Es_OrdenImpresion: 0,
            Es_Confidencial: false,
            Es_Estado: true,
            Es_TiempoDescarte: null,
            Es_CodigoCups: null,
            SysA_AreasAnalisis: study.Tf_Aa_Nombre
              ? {
                  Aa_Id: 0,
                  Aa_Nombre: study.Tf_Aa_Nombre,
                  Aa_OrdenImpresion: 0,
                  Aa_Estado: true,
                }
              : null,
            SysI_Prioridades: null,
          },
        };

        // Agregar el item al array
        setItemsAdded((prev) => [...prev, newItem]);
        newToast('SUCCESS', `Estudio '${study.name}' agregado a la preorden`, 3);
      } catch (error) {
        console.error('Error adding study to preorder:', error);
        newToast('ERROR', 'Error al agregar el estudio a la preorden', 3);
      }
    },
    [itemsAdded, PreorderData.POrd_Cn_Id]
  );

  // Handler para selección de perfil: agrega todos sus estudios marcados con el perfil
  const handleProfileSelected = useCallback(
    (profile: ProfileItem | null) => {
      if (!profile) return;
      try {
        const selectedProfile: any = profile.originalData;
        if (!selectedProfile) {
          newToast('ERROR', 'Perfil no encontrado', 3);
          return;
        }

        const pfeId = selectedProfile.Rpe_Pfe_Id;
        const pfeNombre = selectedProfile.SysI_PerfilesEstudios?.Pfe_Nombre || '';

        // ¿El perfil ya fue agregado?
        if (itemsAdded.some((x) => x.Rpe_Pfe_Id === pfeId)) {
          newToast('INFO', `El perfil '${pfeNombre}' ya ha sido agregado`, 5);
          return;
        }

        const nuevos: FacturacionTarifas[] = [];

        for (const element of selectedProfile.SysI_Estudios || []) {
          // Si el estudio ya está agregado (suelto o en otro perfil), se omite
          if (itemsAdded.some((x) => x.Tf_Es_Id === element.Es_Id) || nuevos.some((x) => x.Tf_Es_Id === element.Es_Id)) {
            continue;
          }
          // El precio se toma de la tarifa del contrato. Si el estudio no tiene
          // tarifa, no pertenece al contrato y simplemente no se agrega.
          const tarifa = (lstTarifas as FacturacionTarifas[]).find((t) => t.Tf_Es_Id === element.Es_Id);
          if (!tarifa) {
            continue;
          }
          nuevos.push({
            ...tarifa,
            Tf_Id: 0,
            Tf_Cn_Id: PreorderData.POrd_Cn_Id || 0,
            Rpe_Pfe_Id: pfeId,
            Profile: pfeNombre,
          });
        }

        if (nuevos.length === 0) {
          newToast('WARNING', `No se agregó ningún estudio del perfil '${pfeNombre}' (ya estaban agregados o no pertenecen al contrato)`, 6);
          return;
        }

        setItemsAdded((prev) => [...prev, ...nuevos]);
        newToast('SUCCESS', `Perfil '${pfeNombre}' agregado con ${nuevos.length} estudio(s)`, 3);
      } catch (error) {
        console.error('Error adding profile to preorder:', error);
        newToast('ERROR', 'Error al agregar el perfil a la preorden', 3);
      }
    },
    [itemsAdded, lstTarifas, PreorderData.POrd_Cn_Id]
  );

  // Convertir estudios agregados a formato para evitar duplicados
  const addedStudiesAsItems = useMemo((): PreorderStudyItem[] => {
    return itemsAdded.map((item) => ({
      id: item.Tf_Es_Id,
      code: item.Estudio?.Es_Codigo || '',
      name: item.Estudio?.Es_Nombre || '',
      group: item.Estudio?.SysA_AreasAnalisis?.Aa_Nombre || 'Sin Área',
      price: item.Tf_Valor,
      // Campos adicionales específicos
      Tf_Es_Id: item.Tf_Es_Id,
      Tf_Es_Codigo: item.Estudio?.Es_Codigo || '',
      Tf_Es_Nombre: item.Estudio?.Es_Nombre || '',
      Tf_Aa_Nombre: item.Estudio?.SysA_AreasAnalisis?.Aa_Nombre || '',
      Tf_ValorTarifa: item.Tf_Valor,
    }));
  }, [itemsAdded]);

  const calculateSubtotal = () => {
    // Calcular el subtotal sumando todos los valores de la columna Tf_Valor
    return itemsAdded.reduce((acc, item) => acc + item.Tf_Valor, 0);
  };

  const updateTotals = () => {
    const subtotal = calculateSubtotal();
    const discountAmount = calculateDiscount(subtotal);
    const total = calculateTotal(subtotal, discountAmount);

    // Actualizar el estado con los nuevos valores
    setTotals({
      subtotal: subtotal,
      discount: discountAmount,
      total: total,
    });
  };

  const calculateDiscount = (subtotal: number) => {
    // Calcular el descuento sobre el subtotal
    //return subtotal * (discount / 100);
    if (discount.type && discount.value > 0) {
      if (discount.type === 'percentage') {
        return subtotal * (discount.value / 100);
      }
      return discount.value;
    }
    return 0;
  };

  const calculateTotal = (subtotal: number, discount: number) => {
    // Calcular el total: subtotal - descuento
    return subtotal - discount;
  };

  const handleClicSave = useCallback(() => {
    if (mode !== 'view' && itemsAdded.length === 0) {
      newToast('WARNING', 'Debe agregar al menos un estudio', 5);
      return;
    }

    const PreOrdData = {
      POrd_Pc_Id: PatientData.Pc_Id,
      POrd_Cn_Id: PreorderData.POrd_Cn_Id,
      POrd_Se_Id: PreorderData.POrd_Se_Id,
      POrd_SubTotal: totals.subtotal,
      POrd_ValorTotal: totals.total,
      POrd_Descuento: totals.discount,
      POrd_TipoDescuento: discount.type === 'percentage' ? 1 : discount.type === 'value' ? 2 : null,
      POrd_TipoDescuentoValor: discount.type ? discount.value : null,
      POrd_CamposDinamicos: JSON.stringify(PreorderData.AditionalFields),
      Detalle: itemsAdded.map((x) => {
        return { Rpre_Es_Id: x.Tf_Es_Id, Rpre_ValUnitario: x.Tf_Valor, Rpre_Cantidad: 1, Rpre_Pfe_Id: x.Rpe_Pfe_Id ?? null };
      }),
    };

    dispatch(setLoading(true));

    switch (mode) {
      case 'new':
        Create(PreOrdData)
          .then(async (x) => {
            if (x && x.POrd_Id) {
              setCurrentPreOrderCreated?.(x.POrd_Id);
              // Cambiar a modo 'view' y cargar los datos de la preorden creada
              const createdData = await GetById(x.POrd_Id);
              if (createdData) {
                const data = createdData.Detalle?.map(mapDetalleToItem) || [];
                setItemsAdded(data);
                createdData.Detalle = undefined;
                dispatch(setData(createdData));
                newToast('SUCCESS', `Preorden creada exitosamente`, 5);
              }
              if (CreateOrderAutomaticInPreorder) {
                // crear un array llamado newItems con los items agregados, x es un solo objeto
                const newItems = [x];
                const SendData = {
                  PreOrders: newItems,
                  IdPrinter: currentPrinter?.Cbp_Id,
                };
                var result = await NewOrderFromPreOrders(SendData);
                if (result && result.length > 0) {
                  newToast('SUCCESS', `Se ha creado la orden '${result[0].OrderNumber}'`, 5);
                  if (result && AutomaticBarcodePrint) {
                    handlePrintBarcodesLabel(result[0].IdOrder);
                  }
                } else {
                  newToast('ERROR', 'No se pudo crear la orden desde la preorden', 5);
                }
              }
            }
          })
          .finally(() => {
            dispatch(setLoading(false));
          });
        break;
      case 'update':
        // Actualizar cotización
        Edit(PreOrdData, PreorderData.POrd_Id).finally(() => {
          dispatch(setLoading(false));
          setVisible(true);
        });
        break;
      default:
        dispatch(setLoading(false));
        break;
    }
  }, [itemsAdded, PreorderData, PatientData, mode, totals]);

  const handleAddDiscount = useCallback(() => {
    if (mode === 'view') {
      return;
    }
    setModalDiscountVisible(true);
  }, [setModalDiscountVisible, mode]);

  const hanAddDiscountConfirm = useCallback(
    (e: { preventDefault: () => void }) => {
      updateTotals();
      setModalDiscountVisible(false);
      e.preventDefault();
    },
    [setModalDiscountVisible, updateTotals]
  );

  const onCancelModalDiscountClick = useCallback(() => {
    setModalDiscountVisible(false);
  }, [setModalDiscountVisible]);

  // Quitar el descuento aplicado: deja tipo/valor en nulo y recalcula totales.
  const handleRemoveDiscount = useCallback(() => {
    discount.type = null;
    discount.value = 0;
    frmRef.current?.instance?.resetValues();
    updateTotals();
    setModalDiscountVisible(false);
  }, [updateTotals]);

  const onTabClick = useCallback((e) => {
    const current = e.itemData;
    setSelectedIndex(current === 'Estudios' ? 0 : 1);
  }, []);

  const renderTab = (item) => {
    if (item === 'Notas') {
      return (
        <span style={{ display: 'inline-flex', alignItems: 'center' }}>
          Notas
          {loadingNotes ? (
            <span style={{ marginLeft: '8px', display: 'flex', alignItems: 'center', height: '100%' }}>
              <LoadIndicator width={15} height={15} />
            </span>
          ) : (
            currentNotes?.length > 0 && (
              <span className='badge-tab' style={{ marginLeft: '5px' }}>
                {currentNotes?.length}
              </span>
            )
          )}
        </span>
      );
    }
    return <span>{item}</span>;
  };

  // Función para renderizar el chip de laboratorio de referencia
  const renderLabRefChip = ({ data }: any) => {
    return <LabRefChip labRefId={data.Estudio?.Es_Lr_Id} labRefData={cmbLabRef} size='small' opacity={0.9} />;
  };

  // Render de la columna CÓDIGO: muestra el código y un distintivo si el estudio viene de un perfil
  const renderCodeCell = ({ data }: any) => {
    return (
      <div className='code-cell'>
        <span>{data.Estudio?.Es_Codigo}</span>
        {data.Rpe_Pfe_Id ? (
          <span id={`profile-badge-${data.Tf_Es_Id}`} className='preorder-profile-badge'>
            P
          </span>
        ) : null}
      </div>
    );
  };

  // Al borrar una fila que pertenece a un perfil, preguntar si se elimina solo ese estudio o todo el perfil
  const handleRowRemoving = (e: any) => {
    if (e.data?.Rpe_Pfe_Id) {
      e.cancel = true;
      setDeleteProfileModal({ studyId: e.data.Tf_Es_Id, profileId: e.data.Rpe_Pfe_Id, profileName: e.data.Profile || '' });
    }
  };

  const handleDeleteOnlyStudy = () => {
    if (deleteProfileModal) {
      setItemsAdded((prev) => prev.filter((x) => x.Tf_Es_Id !== deleteProfileModal.studyId));
    }
    setDeleteProfileModal(null);
  };

  const handleDeleteWholeProfile = () => {
    if (deleteProfileModal) {
      setItemsAdded((prev) => prev.filter((x) => x.Rpe_Pfe_Id !== deleteProfileModal.profileId));
    }
    setDeleteProfileModal(null);
  };

  const handleCancelDeleteProfile = () => {
    setDeleteProfileModal(null);
  };

  return (
    <div>
      <Popup
        title={mode === 'new' ? 'Nueva preorden' : mode === 'update' ? 'Actualizar preorden' : 'Ver preorden'}
        visible={visible}
        showCloseButton={true}
        onHiding={onCancelClick}
        wrapperAttr={{ ...wrapperAttr, class: `${wrapperAttr?.class} form-popup` }}
        height='98%'
        width={'98%'}
        animation={{
          show: { type: 'fade', from: 0, to: 1, duration: 200 },
          hide: { type: 'fade', from: 1, to: 0, duration: 150 },
        }}>
        <div className='view-wrapper view-wrapper-contact-details'>
          <div className='container-forms-ord'>
            <div className={`colOrd-${ColumnsContainerOrderOrders ? ColumnsContainerOrderOrders : 6}`}>
              <Order onClickSave={handleClicSave} onClickCancel={onCancelClick} />
            </div>
            <div className={`colOrd-${ColumnsContainerPatientOrders ? ColumnsContainerPatientOrders : 6}`}>
              <Patient />
            </div>
          </div>
          <div className='dx-card details-card tab-panel-orders'>
            <Tabs className='preorder-tabs' dataSource={listsData} itemRender={renderTab} width={'auto'} selectedIndex={selectedIndex} scrollByContent showNavButtons={false} onItemClick={onTabClick} />

            {selectedIndex === 0 && (
              <div className='detail-values-container' style={{ display: 'flex', height: 'calc(100% - 50px)', overflow: 'hidden' }}>
                <div style={{ flex: '1', display: 'flex', flexDirection: 'column', minWidth: 0, minHeight: 0, marginRight: samplePanelVisible && !(isSmall || isXSmall) ? '4px' : 0 }}>
                <DxToolbar className='preorder-studies-toolbar'>
                  <DxItem location='before'>
                    <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                      <div style={{ flex: '0 0 auto' }}>
                        <PreorderStudiesSearchSelect dataSource={lstTarifas} onStudySelected={handleStudySelected} selectedStudies={addedStudiesAsItems} placeholder='Buscar estudios...' label='Estudios' disabled={mode === 'loading' || mode === 'view' || lstTarifas.length === 0} className='comboboxItems' />
                      </div>
                      <div style={{ flex: '0 0 auto' }}>
                        <ProfilesSearchSelect onProfileSelected={handleProfileSelected} selectedProfiles={[]} placeholder='Buscar perfiles...' label='Perfiles' disabled={mode === 'loading' || mode === 'view' || lstTarifas.length === 0} className='comboboxItems' minSearchLength={1} />
                      </div>
                    </div>
                  </DxItem>

                  {/* Botón de liquidación - Solo si la preorden tiene orden asociada y el usuario puede liquidar */}
                  <DxItem location='after' locateInMenu='never' showText='inMenu' widget='dxButton' visible={mode === 'view' && !!PreorderData?.POrd_Ord_Id && !!Prm_FactCajaLiquidar}>
                    <LiquidarOrden idOrden={PreorderData?.POrd_Ord_Id} valorTotal={totals.total} onLiquidated={refreshPreorderData} />
                  </DxItem>

                  <DxItem location='after' locateInMenu='never'>
                    <div className='separator' />
                  </DxItem>
                  <DxItem location='after' locateInMenu='never' showText='inMenu' widget='dxButton'>
                    <div className='messages'>
                      <Button id='ApplyDisccount' icon={Disccount} text='Aplicar descuento' stylingMode='text' onClick={handleAddDiscount} />
                      {discount.type && discount.value && <div className='dx-badge'>{discount.type === 'percentage' ? `%` : `$`}</div>}
                      <Tooltip target={'#ApplyDisccount'} showEvent='mouseenter' hideEvent='mouseleave' position={'top'}>
                        {discount.type && discount.value ? (discount.type === 'percentage' ? `${discount.value}% aplicado` : `${formatNumber(discount.value, { type: 'currency' })} aplicado`) : 'Aplicar un descuento'}
                      </Tooltip>
                    </div>
                  </DxItem>

                  <DxItem location='after' locateInMenu='never' visible={ModuleFEVRIPS && mode === 'view' && PreorderData?.POrd_FEV && Prm_FactFEVRIPS}>
                    <span className='fevrips-invoice-number'>
                      <strong>Factura:</strong> {PreorderData.POrd_FEV}
                    </span>
                  </DxItem>

                  {/* Botón de FEV/RIPS - Solo visible si el módulo está activo */}
                  <DxItem location='after' locateInMenu='never' visible={ModuleFEVRIPS && mode === 'view' && PreorderData?.POrd_Id && Prm_FactFEVRIPS}>
                    <FEVRIPSStatusButton fevStatus={PreorderData?.POrd_FEV_Estado} ripsStatus={PreorderData?.POrd_RIPS_Estado} enableOptions={AFacturarEnableOptions} fevNumero={PreorderData?.POrd_Nm_Numero} hasOrder={PreorderData?.POrd_Ord_Id != null} onClick={handleOpenFEVRIPSModal} disabled={mode !== 'view'} />
                  </DxItem>

                  {(isSmall || isXSmall) && (
                    <DxItem location='after' locateInMenu='never' showText='inMenu' widget='dxButton'>
                      <Button id='btnMuestrasPre' icon={ordMuestras} text='Muestras' stylingMode='text' onClick={() => setMuestrasPopupVisible(true)} />
                      <Tooltip target={'#btnMuestrasPre'} showEvent='mouseenter' hideEvent='mouseleave' position={'top'}>
                        Ver muestras
                      </Tooltip>
                    </DxItem>
                  )}
                  {!(isSmall || isXSmall) && (
                    <DxItem location='after' locateInMenu='never' showText='inMenu' widget='dxButton'>
                      <Button id='btnToggleMuestrasPre' icon={ordMuestras} text={samplePanelVisible ? 'Ocultar muestras' : 'Muestras'} stylingMode='text' onClick={() => setSamplePanelVisible(!samplePanelVisible)} />
                      <Tooltip target={'#btnToggleMuestrasPre'} showEvent='mouseenter' hideEvent='mouseleave' position={'top'}>
                        {samplePanelVisible ? 'Ocultar panel de muestras' : 'Ver panel de muestras'}
                      </Tooltip>
                    </DxItem>
                  )}
                </DxToolbar>
                <div style={{ flex: 1, minHeight: 0, overflow: 'hidden' }}>
                <DataGrid className='grid' onRowUpdated={updateTotals} onRowRemoved={updateTotals} onRowRemoving={handleRowRemoving} dataSource={itemsAdded} ref={dataGridRef} hoverStateEnabled={true} height='100%' width='100%' repaintChangesOnly={true} highlightChanges={true} rowAlternationEnabled={true} showColumnLines={true}>
                  <Editing allowUpdating mode='cell' allowDeleting={mode === 'new' || mode == 'update'} texts={{ confirmDeleteMessage: '' }} />
                  <Column dataField='Estudio.Es_Codigo' allowEditing={false} caption='CÓDIGO' width={120} alignment='center' cellRender={renderCodeCell} />
                  <Column dataField='Estudio.Es_Lr_Id' allowEditing={false} caption='LAB.REF' width={90} alignment='center' cellRender={renderLabRefChip} />
                  <Column dataField='Estudio.Es_Nombre' allowEditing={false} caption='ESTUDIO' minWidth={250} />
                  <Column dataField='Tf_Valor' caption='TARIFA' dataType='number' format='currency' width={120} minWidth={100} alignment='center' />
                </DataGrid>
                {/* Tooltips de los distintivos de perfil, fuera del grid para que no se reposicionen */}
                {itemsAdded
                  .filter((x) => x.Rpe_Pfe_Id)
                  .map((x) => (
                    <Tooltip key={x.Tf_Es_Id} target={`#profile-badge-${x.Tf_Es_Id}`} showEvent='mouseenter' hideEvent='mouseleave' position='top'>
                      {x.Profile ? `Perfil: ${x.Profile}` : 'Pertenece a un perfil'}
                    </Tooltip>
                  ))}
                </div>
                <div className='totals-summary'>
                  <div>
                    <strong>Subtotal: </strong>
                    <span>{formatNumber(totals.subtotal, { type: 'currency' })}</span>
                  </div>
                  <div>
                    <strong>Descuento: </strong>
                    <span>{formatNumber(totals.discount, { type: 'currency' })}</span>
                  </div>
                  <div>
                    <strong>Total: </strong>
                    <span>{formatNumber(totals.total, { type: 'currency' })}</span>
                  </div>
                </div>
                </div>
                {!(isSmall || isXSmall) && samplePanelVisible && (
                  <div style={{ flex: '0 0 250px', minWidth: 0, minHeight: 0, alignSelf: 'stretch', overflow: 'auto' }}>
                    <SampleTubesPanel data={sampleTubesData} />
                  </div>
                )}
              </div>
            )}
            {selectedIndex === 1 && <NotesPreorders data={currentNotes} updateNotes={updateNotes} />}
          </div>
        </div>
      </Popup>
      <Popup title='Agregar descuento' fullScreen={isSmall || isXSmall} width={400} height={'auto'} visible={modalDiscountVisible} onHiding={onCancelModalDiscountClick} onHidden={onCancelModalDiscountClick} showCloseButton={true}>
        <form action='#' onSubmit={hanAddDiscountConfirm}>
          <Form formData={discount} ref={frmRef}>
            <SimpleItem
              isRequired
              dataField='type'
              editorType='dxSelectBox'
              editorOptions={{
                showClearButton: true,
                items: [
                  { label: 'Porcentaje', value: 'percentage' },
                  { label: 'Valor fijo', value: 'value' },
                ],
                displayExpr: 'label',
                valueExpr: 'value',
              }}>
              <Label text='Tipo de descuento' />
            </SimpleItem>
            <SimpleItem isRequired dataField='value' editorType='dxNumberBox'>
              <Label text='Valor' />
            </SimpleItem>
            <ButtonItem visible={!!discount.type} buttonOptions={{ type: 'danger', text: 'Quitar descuento', useSubmitBehavior: false, onClick: handleRemoveDiscount }} />
            <ButtonItem buttonOptions={{ type: 'default', text: 'Aplicar', useSubmitBehavior: true }} />
          </Form>
        </form>
      </Popup>

      {/* Modal de Facturación Electrónica y RIPS */}
      {ModuleFEVRIPS && PreorderData?.POrd_Id && <ModalFEVRIPS visible={modalFEVRIPSVisible} setVisible={setModalFEVRIPSVisible} idPreorden={PreorderData.POrd_Id} sedeId={sedeId} preorderData={PreorderData} enableOptions={AFacturarEnableOptions} onRefreshData={refreshPreorderData} />}

      {/* Popup para elegir entre eliminar solo el estudio o todo el perfil */}
      <Popup visible={deleteProfileModal !== null} onHiding={handleCancelDeleteProfile} dragEnabled={false} hideOnOutsideClick={false} showCloseButton={true} showTitle={true} title='Eliminar estudio de un perfil' width={isSmall || isXSmall ? '100%' : 500} height='auto' fullScreen={isXSmall}>
        <div style={{ padding: '20px' }}>
          <p style={{ marginBottom: '10px' }}>
            El estudio seleccionado pertenece al perfil <strong>{deleteProfileModal?.profileName}</strong>.
          </p>
          <p style={{ marginBottom: '0' }}>¿Desea eliminar el perfil completo o únicamente el estudio seleccionado?</p>
        </div>
        <PopupToolbarItem toolbar='bottom' location='after'>
          <div className={`form-popup-buttons-container ${isXSmall || isSmall ? 'flex-buttons' : ''}`}>
            <Button text='Solo el estudio' stylingMode='contained' onClick={handleDeleteOnlyStudy} />
            <Button text='Eliminar perfil completo' stylingMode='contained' type='default' onClick={handleDeleteWholeProfile} />
          </div>
        </PopupToolbarItem>
      </Popup>

      {/* Popup de muestras para dispositivos pequeños */}
      {(isSmall || isXSmall) && (
        <Popup
          visible={muestrasPopupVisible}
          onHiding={() => setMuestrasPopupVisible(false)}
          dragEnabled={false}
          hideOnOutsideClick={true}
          showCloseButton={true}
          showTitle={true}
          title='Muestras'
          width={isXSmall ? '100%' : 400}
          height='auto'
          fullScreen={isXSmall}
        >
          <SampleTubesPanel data={sampleTubesData} />
        </Popup>
      )}
    </div>
  );
};

export default Index;



